import type { FaireProductEntity } from "../../entity_types/product";

export const p_2kgkeyy2hn: FaireProductEntity = {
  token: "p_2kgkeyy2hn",
  type: "product",
  name: "flowers watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/e0f33ad099a59af15580107e6cc45e241fd12e7607e70778071c3185903486e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce66e8824d7a9752ed7fc2e0b407b09c07ed27c4d5ece3514e5bab710c31dd19.jpeg",
    "https://cdn.faire.com/fastly/1348ef2dd8ab7381152bb2ee6bcb84f6dcd7ecb5bc2ad00b4e1cc32eaef65d75.jpeg",
    "https://cdn.faire.com/fastly/fe1d0c39568bad5b29ab4302901f63a69108e59d76a321cbb292e7f81ad95d43.jpeg",
    "https://cdn.faire.com/fastly/86154c39f3a90ab5162fcc25cbfd14464fce8672ad215c859097ccd3caafa71d.jpeg",
    "https://cdn.faire.com/fastly/2ef460bf9f01436d748f88a65ed3313e8a109731e5e73360a761f4f4b6fcd4b4.jpeg",
    "https://cdn.faire.com/fastly/24a84c392d1b00f5e46583b80dc7bd6219f7a0ecefdf6c95c6e0b8f18ebe774a.jpeg",
    "https://cdn.faire.com/fastly/9e0ccf32c0ae8a8473d46bc7713a3efd5e1ccb80e921a98e0ea832ea59edc2b8.jpeg",
    "https://cdn.faire.com/fastly/76647ea8c0ef4862e475ca95a1d860425da56e2521c7f3bb0ad95bef4d91001e.jpeg",
  ],
  priceDollars: 12,
  description:
    "A bestselling watercolor workbook that introduces customers to painting through twelve favorite blooms — hydrangea, sunflower, poppy, peony, pansies, lilac, and more. Each illustration is pre-outlined with step-by-step instructions, and paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA strong everyday performer. Sells year-round and pairs naturally with the watercolor paint set and paintbrushes for a complete gift bundle.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:10.212Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
